/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useCallback } from "react";
import { Button, Modal, Card, OverlayTrigger, Popover } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import MyDropzone from "../../../components/DropZone";
import Loader from "../../../components/Loader";
import { useRecoilState, useRecoilValue } from "recoil";
import { fabricAtom, selectedFabricAtom, selectedFabricBandAtom, uploadImageAtom, uploadFabricAtom, showModalAtom, addNewCustomFabricAtom, selectedCustomFabricAtom, beforeSelectedImageScaletom, selectedImageScaletom, aspectRationAtom, cropperSelectionAtom, addBandFabricBeforeAtom, addFabricBeforeAtom, alankaramDataAtom } from "../../../state";
import { GET_FABRICS } from "../graphQl/Query";
import { useLazyQuery } from "@apollo/client";
import { fabricKey, fabricType, ImageGlobalUrl } from "../../../lib/constant";
import { DebounceInput } from "react-debounce-input";
declare global {
    interface Window {
        gtag: (type: string, event: string, params?: any) => void;
    }
}


function CustomModalfilter(props: any) {
    return (
        <>
            <Modal
                show={props.visible}
                onHide={props.toggle}
                className="filter-modal section product-info "
            >
                <Modal.Header closeButton>Fabric Pattern</Modal.Header>
                <Modal.Body>
                    <div className="product-info-row">
                        <div className="right-part">
                            <div className="control-wrapper ">
                                <div className="d-flex align-items-center">
                                    <div className="form-group position-relative me-3">
                                        <input
                                            type="type"
                                            placeholder="Search Paints"
                                            className="search-control mw-88"
                                        />
                                        <img src="/search.png" className="search-icon" />
                                    </div>
                                    <div className="filter-wrapper w-[170px]">
                                        <p>
                                            <img src="filter-2.png" className="search-icon" /> Filter Fabric
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="item-choose w-100 pt-2" >
                            <div
                                className="d-flex align-items-start flex-wrap item-choose-wrapper pt-2 justify-content-center mobile-item">
                                <div className="item-choose mx-2 mb-3">
                                    <img src="Camo.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        camo
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="mosaic.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        mosaic
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3 active">
                                    <img src="floral grey.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Floral Grey <br />
                                        watercolor
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="tropical.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Tropical <br /> leaves
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="peach.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Peach <br /> Flower
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="doodle.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Doodle
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="blue pattern.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Blue Pattern
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="black floral.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Black Floral
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="Camo.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        camo
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="mosaic.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        mosaic
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="floral grey.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Floral Grey <br />
                                        watercolor
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="tropical.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Tropical <br /> leaves
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="peach.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Peach <br /> Flower
                                    </p>
                                </div>
                                <div className="item-choose mx-2 mb-3">
                                    <img src="doodle.png" className="img-fluid" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Doodle
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

const FabricBox = React.memo(({ header, item, setSelectedFabric, pillowSide }: { pillowSide: string, header: string, item: any, setSelectedFabric: Function }) => {
    const [fabricAtomState, setFabricsAtomState] = useRecoilState<{ partWiseFabric: any, currentPart: any, currentMaterial: any }>(fabricAtom);
    const [uploadImage, setUploadImage] = useRecoilState<any>(uploadImageAtom)
    const getCheckSupport = localStorage.getItem('checkSupport')
    const base64Image = item.finish?.search('data:image') !== -1 ? true : false
    const [inputSetValue, setInputSetValue] = useRecoilState<any>(beforeSelectedImageScaletom);
    const [, setSelectedCustomFabricAtom] = useRecoilState(selectedCustomFabricAtom)
    const [inputValue, setInputValue] = useRecoilState(selectedImageScaletom);
    const [, setAspectRation] = useState(aspectRationAtom)
    const [, setCropperData] = useRecoilState(cropperSelectionAtom)
    const [, setAddBandFabricBefore] = useRecoilState(addBandFabricBeforeAtom);
    let selectedFabric = fabricAtomState?.partWiseFabric[fabricAtomState.currentPart[0]];
    const [showPopover, setShowPopover] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handlePopoverOpen = () => setShowPopover(true);
    const handlePopoverClose = () => setShowPopover(false);
    const handleModalClose = () => setShowModal(false);
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

    const checkLog = base64Image ? inputSetValue[pillowSide]?.id === item.id ? 'active' : '' : item._id === selectedFabric?._id ? "active" : ""
    const uploadNewImage = base64Image ? item.finish : `${ImageGlobalUrl}/${getCheckSupport && window?.webpSupport ? item.finish?.replaceAll('.jpg', '.webp') : item.finish}`

    const popover = (
        <Popover id="popover-image-card" style={{ border: "none", boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
            <Popover.Body style={{ padding: 0 }}>
                <Card style={{ width: '14rem', cursor: 'pointer' }} onClick={() => setShowModal(true)}>
                    <Card.Img
                        variant="top"
                        src={uploadNewImage}
                        style={{ height: '220px', objectFit: 'contain' }}
                    />
                    <Card.Body style={{ textAlign: 'center', paddingBottom: '10px', paddingTop: '10px' }}>
                        <Card.Title style={{ fontSize: '0.75rem', margin: '0' }}>
                            {item.name || 'Custom'}
                        </Card.Title>
                    </Card.Body>
                </Card>
            </Popover.Body>
        </Popover>
    );

    return (
        <>
            <div key={item._id} className={`fabric-box item-choose me-3 mb-3 ${checkLog ? "active" : ""} cursor-pointer`}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                onClick={() => {
                    setSelectedFabric(item)
                    if (header === 'FABRIC') {
                        const dynamicKey = pillowSide;
                        const trackMaterialChange = (materialType: any, materialName: any) => {
                            if (typeof window?.gtag === 'function') {
                                window.gtag('event', 'Material_Changed', {
                                    event_category: '3D Viewer',
                                    event_label: `${materialType}: ${materialName}`,
                                    value: 1
                                });
                            }
                        }
                        trackMaterialChange(dynamicKey, base64Image ? "Custom Image" : item?.name)

                        if (base64Image) {
                            setUploadImage({ ...uploadImage, [dynamicKey]: item.finish || uploadImage[dynamicKey] || '' })
                        } else {

                            const { [dynamicKey]: removed, ...rest } = uploadImage;
                            setUploadImage(rest);
                            setInputSetValue({
                                ...inputSetValue,
                                [dynamicKey]: {}
                            })
                        }
                        if (base64Image) {
                            setInputValue({
                                ...inputValue,
                                [pillowSide]: {
                                    "Horizontal": item?.setHorizontal || 0,
                                    "Vertical": item?.setVertical || 0,
                                    "Scale": item?.Scale || 1
                                }
                            })
                            setAspectRation(item?.aspectRation || {})
                            setCropperData(item?.cropperData || {})
                            setSelectedCustomFabricAtom(item)
                            setInputSetValue({
                                ...inputSetValue,
                                [pillowSide]: item
                            })
                        } else {
                            setSelectedCustomFabricAtom({ id: '' })
                        }
                    }
                    if (["BORDER", 'FABRIC'].includes(header)) {
                        if (fabricAtomState?.currentPart?.length > 0) {
                            const partWiseFabric = fabricAtomState.currentPart.reduce((acc: any, part: string) => {
                                acc[part] = item
                                return acc
                            }, {})
                            const newFabric = { ...fabricAtomState, partWiseFabric: { ...fabricAtomState.partWiseFabric, ...partWiseFabric } };

                            setFabricsAtomState({
                                ...newFabric,
                            })
                            if (item?.customBand) {
                                setAddBandFabricBefore(item?.originalImage || '')
                            } else {
                                setAddBandFabricBefore('')
                            }
                        }
                    }
                }}
            >
                {isMobile ? (
                    <img src={uploadNewImage} className="img-fluid" />
                ) : (
                    <OverlayTrigger
                        show={showPopover}
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={popover}
                    >
                        <img src={uploadNewImage} className="img-fluid" />
                    </OverlayTrigger>
                )}


                <p className="font-14 text-center text-black mb-0 !w-[65px] md:!w-[83px] h-[42px]">
                    {item.name ? item.name : 'Custom'}
                </p>
            </div>
            <Modal size="sm" show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton ></Modal.Header>
                <Modal.Body className="container-fluid" style={{ width: '100%', marginBottom: "0" }}>
                    <div className="product-info-row container-fluid px-5 pb-5">
                        <div className="row ">
                            <div className="col-lg-12 left-part mt-rem-6 mt-0 d-flex justify-content-between flex-column p-0" >
                                <img src={uploadNewImage} className="img-fluid" style={{}} />
                                <p className="font-14 text-center text-black mb-0">
                                    {item.name ? item.name : 'Custom'}
                                </p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
});

const FabricSelection = ({ header, materialCategory, subMaterialCategory, type, pillowSide, selectedPart }: { pillowSide: string, header: string, type?: string, setFabric?: Function, materialCategory?: any, subMaterialCategory?: any, selectedPart: string }) => {
    const initLimit = 40
    const [uploadFabricModel, setUploadFabricModel] = useRecoilState<any>(uploadFabricAtom);
    const [, setSelectedFabricBand] = useRecoilState<any>(selectedFabricBandAtom);
    const [modalfilter, setModalfilter] = useState(false);
    const [fabrics, setFabrics] = useState<any[]>([]);
    const [totalFabrics, setTotalFabrics] = useState<number>(0);
    const [, setSelectedFabric] = useRecoilState<any>(selectedFabricAtom);
    const [skip, setSkip] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const uploadImage = useRecoilValue<any>(uploadImageAtom)
    const fabric = useRecoilValue<any>(fabricAtom);
    const [urlData, setUrlData] = useState<string>('')
    const [, setAddFabricBefore] = useRecoilState(addFabricBeforeAtom);
    const [, setShowModal] = useRecoilState(showModalAtom)
    const addNewCustomFabric = useRecoilValue<any>(addNewCustomFabricAtom)
    const alankaramData = useRecoilValue(alankaramDataAtom);

    // Query
    const [getFabricsQuery, { loading }] = useLazyQuery(GET_FABRICS, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getFabrics) {
                const newFabrics = data.getFabrics.finishes || [];
                const total = data.getFabrics.totalFinishes || 0;

                setTotalFabrics(total);

                if (skip === 0) {
                    // Fresh data (search or initial load)
                    setFabrics(newFabrics);
                } else {
                    // Append new data (infinite scroll)
                    setFabrics(prev => [...prev, ...newFabrics]);
                }

                // Update hasMore based on whether we have more data
                setHasMore(skip + newFabrics.length < total);
            }
            setIsLoading(false);
        },
        onError: () => {
            setIsLoading(false);
        }
    });

    // Reset when subMaterialCategory changes
    useEffect(() => {
        setSkip(0);
        setFabrics([]);
        setHasMore(true);
    }, [subMaterialCategory]);

    // Load data when dependencies change
    useEffect(() => {
        if (subMaterialCategory && materialCategory) {
            setIsLoading(true);
            getFabricsQuery({
                variables: {
                    "input": {
                        "limit": initLimit,
                        "skip": skip,
                        "type": fabricType,
                        "key": fabricKey,
                        "companyId": alankaramData?.companyId || "",
                        ...(search !== "" && { name: search }),
                        meterialId: subMaterialCategory,
                        parentMaterialId: materialCategory,
                        published: alankaramData?.companyId === "5feac293447a060008714d9f" ? false : true
                    }
                }
            });
        }
    }, [skip, search, subMaterialCategory, materialCategory, alankaramData?.companyId]);

    // Load more data for infinite scroll

    const loadMoreData = () => {
        if (!hasMore || !Boolean(fabrics?.length)) return;
        const newOffset = skip + 40;
        setSkip(newOffset);
    };


    // Handle search with debounce
    const handleSearchChange = useCallback((value: string) => {
        setSearch(value);
        setSkip(0);
        setFabrics([]);
        setHasMore(true);
    }, []);

    if (!uploadFabricModel) {
        let fabricAllData = [
            ...addNewCustomFabric.filter((element: any) => element.selectedPart === selectedPart),
            ...fabrics
        ];
        
        return (
            <>
                <div className="control-wrapper fabric-block">
                    {window.screen.availWidth > 944 && (
                        <div className="d-flex align-items-center fabric-input-wrapper w-100">
                            <div className={`form-group position-relative me-3 select-input !max-w-full`}>
                                <DebounceInput
                                    className="search-control max-w-100 w-100"
                                    placeholder="Search..."
                                    autoComplete="off"
                                    value={search}
                                    debounceTimeout={500}
                                    autoFocus={false}
                                    onChange={(e) => handleSearchChange(e.target.value)}
                                />
                                <img src="/search.png" className="search-icon" />
                            </div>
                        </div>
                    )}

                    <div className="item-choose w-100 pt-2">
                        <div id="scrollableDiv" className="scrollableDivCss">
                            <InfiniteScroll
                                className="d-flex align-items-start flex-wrap item-choose-wrapper pt-2 max-w-100 w-100 infinite_scroll"
                                dataLength={fabricAllData?.length}
                                next={loadMoreData}
                                hasMore={hasMore}
                                loader={<Loader />}
                                scrollThreshold={0.8}
                                scrollableTarget="scrollableDiv"
                            // endMessage={
                            //     fabricAllData.length > 0 && (
                            //         <p className="w-100 text-center text-muted mt-3">
                            //             All fabrics loaded
                            //         </p>
                            //     )
                            // }
                            >
                                <div className="fabric-box item-choose me-3 mb-3 cursor-pointer" onClick={() => {
                                    setSelectedFabricBand('FABRIC')
                                    setUploadFabricModel(true)
                                }}>
                                    <img src="/Group 1783.png" className="img-fluid add-fabric-button" />
                                    <p className="font-14 text-center text-black mb-0 mt-2">
                                        Add
                                    </p>
                                </div>

                                {loading && skip === 0 && (
                                    <div className="w-100 d-flex justify-content-center">
                                        <Loader />
                                    </div>
                                )}

                                {fabricAllData?.map((item: any, i: number) => (
                                    <FabricBox
                                        key={item._id || `custom-${i}`}
                                        pillowSide={pillowSide}
                                        item={item}
                                        setSelectedFabric={(data: any) => {
                                            setSelectedFabric(data)
                                        }}
                                        header={header}
                                    />
                                ))}
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
                <CustomModalfilter
                    btnName="Name"
                    modalBody="THIS IS CUSTOM MODAL"
                    closeBtnName="CLOSE"
                    okBtnName="OK"
                    modalHeading="THIS IS HEADING!!"
                    toggle={() => setModalfilter(!modalfilter)}
                    visible={modalfilter}
                />
            </>
        );
    }
    else {
        return (
            <div>
                <div className="d-flex justify-content-between px-4 pt-4" >
                    <h4 className="font-17">UPLOAD IMAGE</h4>
                    <div className="cursor-pointer" onClick={() => setUploadFabricModel(false)}>X</div>
                </div>
                <div className="p-4">
                    <MyDropzone />
                    <div className="separator my-5">OR</div>
                    <label className="mb-2">URL</label>
                    <div className="d-flex">
                        <input className="reset-input-style me-2 w-100" type="url" onChange={(e) => setUrlData(e.target.value)} placeholder="https://alankaram.netlify.app/" />
                        <Button className="w-min-126px" variant="primary" type="submit" onClick={() => {
                            if (urlData?.length) {
                                setAddFabricBefore({ ...uploadImage, [fabric?.currentPart?.[0]]: urlData })
                                setShowModal(true)
                                setUploadFabricModel(false)
                            }
                        }}>
                            Upload
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default React.memo(FabricSelection);